import React from 'react'

const About = () => {
    return (
        <div>
            <h1>Meet The Team</h1>
            <div className="kyle">
                <div className="contentContainer kyle__content">
                    <div className="kyle__imageContainer">
                        <img alt="Kyle Willard" src="/assets/k_profile.jpeg" />
                    </div>
                    <div className="kyle__textContainer">
                        <h3>Kyle Willard</h3>
                        <article className="kyle__paragraphs">
                            <p>
                                Kyle has been a long-time salesman and sales
                                manager in both wireless sales and automotive
                                industries. During his time with a premium
                                Sprint retailer in 2012, he was touted as one of
                                the top 2 salespeople to leverage the most
                                profitable part of wireless sales, accessories.
                                In the last few years, he was employed as the
                                primary administrator for an Automotive Dealer
                                Association where he created and maintained a
                                WordPress-powered education & e-commerce
                                application. His skills in sales brought in a
                                ton of new automotive dealers and set them on
                                the right track to succeed. His time at this
                                automotive association also included a ton of
                                time dedicated to teaching automotive dealers
                                how to better do their jobs through robust
                                educational content that he developed in
                                coordination with the Oregon Department of Motor
                                Vehicles.
                            </p>
                            <p>
                                However, during that time he helped build
                                systems with the auto dealership that he was
                                housed in creating marketing and sales channels,
                                and was heavily involved in the revamp of the
                                dealership's website in coordination with their
                                existing site provider. With his analysis and
                                ideas, his work with that provider has netted an
                                overall increase of 12-20% increased traffic.
                            </p>
                            <p>
                                If you want to evolve your web presence into a
                                sales powerhouse Kyle's sales know-how, and
                                development skills will take you to the next
                                level. But during the journey, he will be able
                                to in simple terms communicate the why, and how
                                of each step to help you feel comfortable with
                                the changes that are made.
                            </p>
                        </article>
                    </div>
                </div>
                <div className="custom-shape-divider-bottom-1629763950">
                    <svg
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1200 120"
                        preserveAspectRatio="none"
                    >
                        <path
                            d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
                            className="shape-fill"
                        ></path>
                    </svg>
                </div>
            </div>
            <div className="jesse">
                <div className="contentContainer jesse__content">
                    <div className="custom-shape-divider-top-1629824936">
                        <svg
                            data-name="Layer 1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1200 120"
                            preserveAspectRatio="none"
                        >
                            <path
                                d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
                                className="shape-fill"
                            ></path>
                        </svg>
                    </div>
                    <div className="jesse__imageContainer">
                        <img alt="Jesse Medrano" src="/assets/j_profile.jpeg" />
                    </div>
                    <div className="jesse__textContainer">
                        <h3>Jesse Medrano</h3>
                        <article className="jesse__paragraphs">
                            <p>
                                Jesse is fullstack web developer that
                                specialized in finding innovative technology and
                                integrating them into any project that will
                                benefit from it. His main programing languages
                                are typescript and javascript. Jesse also has an
                                eye for design and finds peace in translating
                                those designs to code with pixel perfect
                                accuracy.
                            </p>
                            <p>
                                Jesse wasn't always a web developer. He started
                                working with tools like Adobe Photoshop while in
                                highschool where he would make flyers, posters,
                                cd art and more for his band. There he practiced
                                his craft and learned he can create stunning
                                designs that would contribute to bringing
                                audiences to fill concert halls. Shortly after
                                high school, he began his career in sales.
                            </p>
                            <p>
                                Jesse was involved in wireless sales and
                                insurance sales for many years. In these days,
                                he had much time serving customers, creating
                                custom solutions for business and families, and
                                learning the skills necessary create value in
                                products and services. It was also in this time
                                Jesse became a multi-store manager, he was able
                                to serve customers efficiently and ethically.
                                Jesse took pride in educating and team
                                management and brings this level of leadership
                                to teams of all types and sizes.
                            </p>
                            <p>
                                Jesse has a knack for bringing his experiences
                                into his work. Jesse believes the best products
                                and services have the best teams to serve them.
                                Jesse is confident if you chose to work with New
                                Evolution Design, that would have the best team
                                that understands your business needs and can
                                translate those needs into a web platform or
                                solution.
                            </p>
                        </article>
                    </div>
                    <div className="custom-shape-divider-bottom-1629770768">
                        <svg
                            data-name="Layer 1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1200 120"
                            preserveAspectRatio="none"
                        >
                            <path
                                d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
                                opacity=".25"
                                className="shape-fill"
                            ></path>
                            <path
                                d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
                                opacity=".5"
                                className="shape-fill"
                            ></path>
                            <path
                                d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
                                className="shape-fill"
                            ></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
